import axios from 'axios'

/**
 *
 * @param {*} cid AdCash click ID
 * @param {*} eventType AdCash event type (Reegistration|Installation|CPA Target|Sale|Sale(%)|Lead|Custom)
 * @returns
 */
export const trackAdCashEvent = async (cid, eventType, id) => {
    try {
        if (!cid) {
            console.log('No AdCash click ID provided, skipping AdCash tracking')
            return false
        }

        const url = `https://www.pixelhere.com/et/event.php?advertiser=330066&cid=${cid}&id=${id}`

        console.log('Firing AdCash event:', url)
        await axios.get(url)
        console.log('AdCash event fired successfully:', url)
        return true
    } catch (error) {
        console.error('Error tracking AdCash event:', error)
        return false
    }
}

export default {
    trackAdCashEvent,
}
